import axios from "axios";

const SitevisionHeaders= {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
}

export const search = (url: string, categories: string, startDate: string, endDate: string, page: string): Promise<any> => 
    axios.get<any>(url, {
            params: {
                categories,
                startDate,
                endDate,
                page,
            },
            headers: {
                ...SitevisionHeaders
            }
        })
        .then(response => {
            return response.data;
        }).catch(mesg => {
            console.error('ERROR: ' + JSON.stringify(mesg));
        })